import { Component, OnInit, Input,ViewChild,ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import {UploadReportComponent} from '../upload-report/upload-report.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { actionButtonConfiguration } from '../../../../../l2-radiology/src/assets/data/actionButtonConfiguration';
import { NgxSpinnerService } from "ngx-spinner";
import { ThrowStmt } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-prescription-upload',
  templateUrl: './prescription-upload.component.html',
  styleUrls: ['./prescription-upload.component.scss']
})
export class PrescriptionUploadComponent implements OnInit {

  @ViewChild('imageInput') imageInput: ElementRef;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    public modal: NgbActiveModal,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  documents: [];
  uploadForm: FormGroup;
  @Input() orderObj;
  @Input() isPrescriptionUploadReportBtn;
  @Input() channel_code;
  order_id: string;
  msg: string = "";
  isReportUploaded: Boolean = false;

  contactNumber = "";
  emailAddress = "";
  activeComponentId = "";
  isPrescriptionSend: boolean = false;
  prescriptionResponse = {};
  actionButtonConfiguration;


  viewSendPrscriptionLink: boolean = false;
  sendPrescriptionLink: boolean = false;
  uploadPrescriptionLink: boolean = false;
  isDelete: Boolean = false;

  isSuccessMsg: Boolean = false;
  isFailureMsg: Boolean = false;

  ngOnInit(): void {


    this.documents = this.orderObj.order.documents;
    this.order_id = this.orderObj.order.patientinfo.order_id;
    this.contactNumber = this.orderObj.order.patientinfo.contact;
    this.emailAddress = this.orderObj.order.patientinfo.email;
    this.activeComponentId = this.orderObj.active_component;
    //this.actionButtonConfiguration = actionButtonConfiguration;
    //this.viewSendPrscriptionLink =this.getConfigurationData(actionButtonConfiguration[0].sendPrescriptionLink,window.localStorage.getItem('role'));

    let viewPrescptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].viewPrescriptionLink, window.localStorage.getItem('role'));
    var viewPrescptionLinkObjStatus = viewPrescptionLinkObj["status"];
    if (viewPrescptionLinkObjStatus !=null && viewPrescptionLinkObjStatus !=undefined && viewPrescptionLinkObjStatus.includes(this.orderObj.OStatus)) {
      this.viewSendPrscriptionLink = true;
    }

    let sendPrescptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].sendPrescriptionLink, window.localStorage.getItem('role'));
    var sendPrescptionLinkObjStatus = sendPrescptionLinkObj["status"];
    if (sendPrescptionLinkObjStatus !=null && sendPrescptionLinkObjStatus !=undefined && sendPrescptionLinkObjStatus.includes(this.orderObj.OStatus)) {
      this.sendPrescriptionLink = true;
    }
    //                            

    let prescriptionUploadReportObj = this.getConfigurationData(actionButtonConfiguration[0].uploadPrescriptionLink, window.localStorage.getItem('role'));
    var uploadReportObjStatus = prescriptionUploadReportObj["status"];
    if (uploadReportObjStatus !=null && uploadReportObjStatus !=undefined && uploadReportObjStatus.includes(this.orderObj.OStatus)) {
      this.isPrescriptionUploadReportBtn = true;

    }


    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });


    if (this.orderObj.OStatus == 1001) {
      this.isDelete = true;
    }
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }


  }




  onSubmit(orderId) {
    this.SpinnerService.show();
    this.msg = "";

    let formData = new FormData();

    formData.append('file[]', this.uploadForm.get('profile').value);

    formData.append("order_id", orderId);
    formData.append("channelCode", this.constantsService.CHANNEL_CODE);

    //formData.append("channelCode",this.channel_code);
    formData.append("actionById", window.localStorage.getItem('actionById'));
    formData.append("actionByName", window.localStorage.getItem('actionByName'));

    formData.append("source", "2");
    formData.append("orgCode", "100001");
    formData.append("tenantCode", "100001");

    this.omsServiceService.uploadPrescriptionFile(formData).subscribe(
      (res) => {

        //console.log(res);
        if (res["status"] == 1) {
          this.imageInput.nativeElement.value = '';
          this.uploadForm.get('profile').reset()
          this.isReportUploaded = true;
           this.getOrderDataById(orderId);
          this.msg = res["message"];
          this.isSuccessMsg = true;
          // this.changeOrderStatus(orderId);
        } else {
          this.msg = res["message"];
          this.isFailureMsg = true;
        }
        this.SpinnerService.hide();
      }

    )

  }


  changeOrderStatus(orderId) {

    if (this.documents != undefined && this.documents.length > 0) {
         this.SpinnerService.show();
      let orderStatusChangeRequest = {};
      orderStatusChangeRequest["order_id"] = orderId;
      orderStatusChangeRequest["actionByName"] = window.localStorage.getItem('actionByName');
      orderStatusChangeRequest["actionById"] = window.localStorage.getItem('actionById');
      orderStatusChangeRequest["source"] = "1";
      // orderStatusChangeRequest["status"] = this.constantsService.REPORT_UPLOADED_STATUS;
      orderStatusChangeRequest["status"] = this.constantsService.PRESCRIPTION_UPLOADED_STATUS;
      orderStatusChangeRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
      orderStatusChangeRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
      orderStatusChangeRequest["type"] = "post";
      //orderStatusChangeRequest["channelCode"] =  this.channel_code;
      this.omsServiceService.changeStatusBasedOnReportUpload(orderStatusChangeRequest).subscribe(
        (res) => {
          //console.log(res);
          this.SpinnerService.hide();
          this.getOrderDataById(orderId);
        }
      )

    } else {

      // alert("please upload atleast one prescription");
      this.toastr.error("please upload atleast one prescription");
    }


  }

  getOrderDataById(id) {
    let orderRequest = {};
    orderRequest["actionById"] = window.localStorage.getItem('actionById');

    //this.orderRequest["actionById"] = "900001";

    orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    //orderRequest["channelCode"] = this.channel_code;
    orderRequest["order_id"] = id;
    this.omsServiceService.getOrderDetails(orderRequest).subscribe(
      (res) => {

        if (res['status'] == 1) {
          // if(res["data"][0]["orderDetails"].order != undefined && res["data"][0]["orderDetails"].order.documents != undefined)
          //   {
          //this.documents =res["data"][0]["orderDetails"].order.documents;
          this.documents = res["data"][0].orderDetails[0].order.documents;
          this.enableButtons(res["data"][0]["orderDetails"]);
          // }

        }
      }

    )
  }

  openBackDropCustomClass(content) {
    this.modalService.open(content, { windowClass: 'commonStyleModals' });
  }

  sendPrescriptionUrl() {
    this.sendUrl();
  }

  sendUrl() {
    let orderRequest = {};
    orderRequest["method"] = "OMS/api/operation.php/v1/orders/notification/send/prescription-upload-link";
    orderRequest["type"] = "post";
    orderRequest["order_id"] = this.order_id;
    orderRequest["component_id"] = this.activeComponentId;
    orderRequest["source"] = "CCO";
    //orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    //orderRequest["channelCode"] = this.channel_code;
    orderRequest["channelCode"] = 2;
    orderRequest["actionById"] = window.localStorage.getItem('actionById');

    this.omsServiceService.sendPrescriptionUrl(orderRequest).subscribe(
      (res) => {
        this.prescriptionResponse = res["message"];
        this.isPrescriptionSend = true;


        if (res["success"] == 1) {
          this.changeStatusBasedOnPrescription(this.order_id);
        }
      }
    )
  }


  changeStatusBasedOnPrescription(orderId) {
    let prescrionPrndingStatusRequest = {};


    prescrionPrndingStatusRequest["order_id"] = orderId;


    prescrionPrndingStatusRequest["actionByName"] = window.localStorage.getItem('actionByName');
    prescrionPrndingStatusRequest["actionById"] = window.localStorage.getItem('actionById');
    prescrionPrndingStatusRequest["source"] = "1";
    //prescrionPrndingStatusRequest["status"] = this.constantsService.PRESCRIPTION_PENDING_STATUS;
    prescrionPrndingStatusRequest["status"] = 1001;
    prescrionPrndingStatusRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    //prescrionPrndingStatusRequest["channelCode"] = this.channel_code;
    prescrionPrndingStatusRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    prescrionPrndingStatusRequest["type"] = "post";

    //channelCode
    this.omsServiceService.changeStatusBasedOnPrescription(prescrionPrndingStatusRequest).subscribe(
      (res) => {
        //console.log(res);
        this.getOrderDataById(orderId);
      }
    )
  }

  getConfigurationData(listOfData, role) {
    let obj = {};
    for (let data of listOfData) {
      //console.log(data.role);
      if (role == data.role) {
        obj = data;
      }

    }
    return obj;
  }

  closePopup() {
    this.modal.close();
  }

  download(docId) {

    let downloadFileRequest = {};
    downloadFileRequest["doc_id"] = docId;
    downloadFileRequest["action"]="OMS/api/uploader.php/v4/orders/document/id";
    downloadFileRequest["type"]="post";
    this.omsServiceService.downloadFile(downloadFileRequest).subscribe(
      (res) => {
        //console.log(res);
        if (res["status"] == 1) {
          //res["data"].url
          window.open(res["data"].url, '_blank');
          // window.location.href = res["data"].url;

        }
      }
    )
  }

  delete(docId, docName) {

    this.SpinnerService.show();
    let deleteFileRequest = {};
    deleteFileRequest["order_id"] = this.order_id;
    deleteFileRequest["doc_id"] = docId;
    deleteFileRequest["filename"] = docName;
    //deleteFileRequest["channelCode"]=this.channel_code;
    deleteFileRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    deleteFileRequest["actionById"] = window.localStorage.getItem('actionById');
    deleteFileRequest["action"]="OMS/api/uploader.php/v4/orders/prescriptions/delete";
    deleteFileRequest["type"]="post";
    this.omsServiceService.deletePrescription(deleteFileRequest).subscribe(
      (res) => {
        //console.log(res);
        if (res["status"] == 1) {
          //console.log(res);
          //res["data"].url
          // window.open(res["data"].url,'_blank');
          // window.location.href = res["data"].url;
          this.msg = res["message"];
          this.getOrderDataById(this.order_id);
        } else {
          this.msg = res["message"];
        }
        this.SpinnerService.hide();
        //console.log(res);
      }
    )
  }


  enableButtons(res) {
    this.viewSendPrscriptionLink = false;
    this.sendPrescriptionLink = false;
    this.isPrescriptionUploadReportBtn = false;
    let viewPrescptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].viewPrescriptionLink, window.localStorage.getItem('role'));
    var viewPrescptionLinkObjStatus = viewPrescptionLinkObj["status"];
    if (viewPrescptionLinkObjStatus !=null && viewPrescptionLinkObjStatus!=undefined && viewPrescptionLinkObjStatus.includes(res[0].OStatus)) {
      this.viewSendPrscriptionLink = true;
    }

    let sendPrescptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].sendPrescriptionLink, window.localStorage.getItem('role'));
    var sendPrescptionLinkObjStatus = sendPrescptionLinkObj["status"];
    if (sendPrescptionLinkObjStatus !=null && sendPrescptionLinkObjStatus !=undefined && sendPrescptionLinkObjStatus.includes(res[0].OStatus)) {
      this.sendPrescriptionLink = true;
    }
    //                            

    let prescriptionUploadReportObj = this.getConfigurationData(actionButtonConfiguration[0].uploadPrescriptionLink, window.localStorage.getItem('role'));
    var uploadReportObjStatus = prescriptionUploadReportObj["status"];
    if (uploadReportObjStatus !=null && uploadReportObjStatus !=undefined && uploadReportObjStatus.includes(res[0].OStatus)) {
      this.isPrescriptionUploadReportBtn = true;

    }


  }

  prescriptionUploadCompleted(orderId) {

    this.SpinnerService.show();
    let prescrionPrndingStatusRequest = {};


    prescrionPrndingStatusRequest["order_id"] = orderId;


    prescrionPrndingStatusRequest["actionByName"] = window.localStorage.getItem('actionByName');
    prescrionPrndingStatusRequest["actionById"] = window.localStorage.getItem('actionById');
    prescrionPrndingStatusRequest["source"] = "1";
    //prescrionPrndingStatusRequest["status"] = this.constantsService.PRESCRIPTION_PENDING_STATUS;
    prescrionPrndingStatusRequest["status"] =26;
    prescrionPrndingStatusRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    //prescrionPrndingStatusRequest["channelCode"] = this.channel_code;
    prescrionPrndingStatusRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    prescrionPrndingStatusRequest["type"] = "post";

    //channelCode
    this.omsServiceService.changeStatusBasedOnPrescription(prescrionPrndingStatusRequest).subscribe(
      (res) => {
        //console.log(res);
        this.SpinnerService.hide();
        if(res["status"]==1)
        {
            this.msg=res["message"];
            this.SpinnerService.hide();
          this.getOrderDataById(orderId);
          
        }
        
      }
    )
  }
}
